import React from 'react';
import Stargolden from '../../../../system/access/images/ats/star__golden.png';
import moment from 'moment';
import styled from 'styled-components';
import { palette } from '../../../../system/styles/styles';
import { useTranslation } from 'react-i18next';
import GeneralAccordion from './GeneralAccordion';
import Star from '../../../../system/access/images/ats/star.png';

const ContainerArticle = styled.article`
  //margin-top: 24px;
  height: calc(100vh - 190px);
  overflow-y: auto;
  position: relative;
  padding: 15px;
  &::-webkit-scrollbar {
    width: 0.5em;
    height: 0.5em;
  }
  &::-webkit-scrollbar-track {
    background-color: #f2f2f2;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 0.5rem;
  }
  .subModal {
    // padding: 16px;
    width: 100%;
    height: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    transition: bottom 0.5s cubic-bezier(0, 0, 0.58, 1);
    overflow: auto;
    //background-color: rgba(0,0,0,.36);
    z-index: 100;
    border-radius: 8px;

    display: grid;
    justify-items: center;
    align-items: end;
    .bx_body_subModal {
      width: 100%;
      height: 80%;
      padding-top: 2%;
      //display: flex;
      //flex-direction: column;
      display: grid;
      grid-template-rows: 15% 25% 9% 50%;
      background-color: #ffffff;
      border-radius: 8px 8px 0px 0px;
      @media screen and (max-width: 1366px) {
        height: 85%;
        grid-template-rows: 10% 18% 10% 62%;
      }
    }
    .fields {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .textField {
      width: 90%;
      margin: 2% auto;
    }
    .titleSubmodal {
      font-family: ${palette.nereg};
      font-size: 18px;
      em {
        font-size: 12px;
      }
      @media screen and (max-width: 1366px) {
        font-size: 13px;
        em {
          font-size: 10px;
        }
      }
    }
    .body_container {
      width: 100%;
      padding: 16px;
      overflow: auto;
      &::-webkit-scrollbar {
        width: 0.5em;
        height: 0.5em;
      }
      &::-webkit-scrollbar-track {
        background-color: #f2f2f2;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 0.5rem;
      }
    }
  }
  .buttonCriterial_Add {
    width: 90%;
    min-height: 30px;
    margin: 2% auto;
    justify-content: center;
    font-size: 12px;
    font-family: ${palette.nereg};
  }
  .buttomFloat {
    width: 50px;
    height: 50px;
    position: absolute;
    left: calc(100% - 55px);
    background-color: #506eec;
    top: calc(100% - 55px);
    z-index: 10000;
    border-radius: 25px;
    //box-shadow: 0 4px 15px 0 rgba(0,0,0,.3);
    opacity: 0.5;
    transition: 0.3s;
    transform: scale(1);
    justify-content: center;
    align-items: center;
    display: flex;
    &:hover {
      opacity: 1;
    }
    &:focus {
      outline: none;
    }
  }
  .extraHidden {
    width: 100%;
    height: 100%;
    position: absolute;
    background: rgba(0, 0, 0, 0.36);
    overflow: hidden;
    z-index: -1000;
    transition: 0.5s;
    transition-property: z-index;
    transition-duration: 0.5s;
    transition-delay: 0.5s;
  }
  .extraHiddenTwo {
    width: 100%;
    height: 100%;
    position: absolute;
    background: rgba(0, 0, 0, 0.36);
    overflow: hidden;
    z-index: 100;
  }
  .inactive {
    bottom: -100%;
    transition: bottom 0.5s cubic-bezier(0, 0, 0.58, 1);
  }
  .bx_1_2_2 {
    display: grid;
    grid-template-columns: 10% 45% 45%;
    margin: 1% auto;
    width: 70%;
    img {
      justify-self: center;
      align-self: center;
    }
  }
  .bx_1 {
    display: grid;
    //grid-template-columns: 10% 45% 45%;
    margin: 1% auto;
    width: 70%;
    .label_Title {
      width: 100%;
      text-align: start;
    }
  }
  .bx-1-2 {
    display: grid;
    grid-template-columns: 1fr 2fr;
    margin: 1% auto;
    width: 100%;
  }
  label {
    margin-top: 10px;
    font-size: 16px;
    margin-bottom: 10px;
  }
  p {
    font-size: 14px;
  }
  img {
    width: 30px;
    height: 30px;
    //cursor: pointer;
  }
  button {
    padding: 5px 20px;
    font-size: 14px;
    color: ${palette.white};
    background-color: ${palette.blue};
    margin: auto;
    display: flex;
  }
  .Promedio {
    margin: 20px 0px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: initial;
  }
  .Promedio p {
    margin: initial;
    font-size: 3rem;
  }
  .Promedio img {
    margin: 5px 0px 0px 20px;
    width: 50px;
    height: 50px;
  }
  .Other {
    margin: 20px 0px;
    flex-direction: row;
    display: flex;
    width: 100%;
  }
  .Other__round {
    width: 50px;
    height: 50px;
    border-radius: 25px;
    background-color: #ffd700;
    justify-content: center;
    align-items: center;
    display: flex;
  }
  .Other__round p {
    margin: auto;
    font-size: 25px;
    text-align: center;
    color: ${palette.white};
  }
  .center {
    margin: 20px auto;
    justify-content: center;
    display: flex;
    gap: 7px;
    img {
      cursor: pointer;
    }
  }
`;

const CalificationStep = (props) => {
  const { post, updateStar, divStar, onClickUpdate, promedio, history, timestamp } = props;
  const { t } = useTranslation(['applicant']);
  const [expanded, setExpanded] = React.useState('starMain');

  const handleChange = (value) => {
    setExpanded(value);
  };
  const startGeneral = (count) => {
    const divStar = [];
    for (let i = 0; i < count; i++) {
      divStar.push(<img key={i} style={{ cursor: 'default' }} src={Stargolden} alt={`${i} de 5 estrellas`} />);
    }
    for (let i = count; i < 5; i++) {
      divStar.push(<img key={i} style={{ cursor: 'default' }} src={Star} alt={`${i} de 5 estrellas`} />);
    }
    return divStar;
  };

  return (
    <ContainerArticle>
      <label style={{ fontWeight: 'bold' }}>{t('Scores')}</label>
      <div className="bx_1_2_2">
        <img src={Stargolden} alt={`${promedio} estrellas`} /> <label>{t('AverageScore')}</label>
        <label>{promedio} </label>
      </div>

      <GeneralAccordion
        key="10000"
        handleChange={handleChange}
        name="starMain"
        expanded={expanded}
        title={t('Score')}
        main>
        <div className="center">{divStar}</div>
      </GeneralAccordion>
      <br />
      <label style={{ marginTop: '20px', fontWeight: 'bold' }}>{t('OtherScores')}</label>
      <div>
        {promedio ? (
          Object.values(history).map((e, index) => (
            // <div key={index} className="Other">
            //   <div className="Other__round">
            //     <p>{e.star}</p>
            //   </div>
            //   <div style={{ marginLeft: '10px' }}>
            //     <p>{e.email}</p>
            //     <p>{moment(e.timestamp).format('LL')}</p>
            //   </div>
            // </div>
            <GeneralAccordion
              key="10000"
              handleChange={handleChange}
              name={e.email}
              expanded={expanded}
              title={`${e.email} ${moment(e.timestamp).format('LL')}`}
              main>
              <div className="center">{startGeneral(e.star)}</div>
            </GeneralAccordion>
          ))
        ) : (
          <p>Nadie lo ha calificado aún, se el primero.</p>
        )}
      </div>
    </ContainerArticle>
  );
};

export default CalificationStep;
